import type * as http from "http";
import { createContext } from "react";

export default createContext<http.ServerResponse | null>(null);
